import { PERFORMANCE_CALCULATORS_AUTO, PERFORMANCE_CALCULATORS_SAM_2025_R1 } from 'constants/calculators'
import { authSelectors } from 'ducks/auth'
import React, { useEffect } from 'react'
import { useTranslate } from 'react-admin'
import { useForm, useFormState } from 'react-final-form'
import { useSelector } from 'react-redux'
import { DYNAMIC_SNOW_SUPPORTED_COUNTRIES, SNOW_MODE_DYNAMIC, SNOW_MODE_FIXED_PERCENTAGE } from './constants'
import { SnowDataProviderField } from './SnowDataProviderField'
import { SnowLossPercentageField } from './SnowLossPercentageField'
import { SnowSimulationModeField } from './SnowSimulationModeField'

interface SnowLossesProps {
  allowEdit: boolean
  [key: string]: any
}

const styles = {
  detailStyle: {
    width: 200,
    padding: '0 5px 0 0',
  },
}

export const SnowLosses: React.FC<SnowLossesProps> = ({ allowEdit, ...props }) => {
  const translate = useTranslate()
  const formState = useFormState()
  const { change } = useForm()
  const orgCountry = useSelector(authSelectors.getCurrentOrgCountry) || ''
  const performanceCalculator = formState.values.performance_calculator
  const supportsDynamicSnowUi =
    performanceCalculator === PERFORMANCE_CALCULATORS_SAM_2025_R1 ||
    performanceCalculator === PERFORMANCE_CALCULATORS_AUTO
  const isCountrySupported = DYNAMIC_SNOW_SUPPORTED_COUNTRIES.includes(orgCountry)
  const canUseDynamicMode = supportsDynamicSnowUi && isCountrySupported
  const currentMode = formState.values.sam_snow_mode

  // If Dynamic mode is selected but not supported (wrong calculator or country), reset to Fixed Percentage
  useEffect(() => {
    if (!canUseDynamicMode && currentMode === SNOW_MODE_DYNAMIC && allowEdit) {
      change('sam_snow_mode', SNOW_MODE_FIXED_PERCENTAGE)
    }
  }, [canUseDynamicMode, currentMode, allowEdit, change])

  return (
    <>
      <h3>{translate('Snow Losses')}</h3>
      <div style={{ display: 'flex', alignItems: 'flex-start', marginBottom: 16, flexWrap: 'wrap', gap: 8 }}>
        <SnowSimulationModeField
          allowEdit={allowEdit}
          canUseDynamicMode={canUseDynamicMode}
          style={styles.detailStyle}
        />
        <SnowDataProviderField allowEdit={allowEdit} style={styles.detailStyle} />
        <SnowLossPercentageField allowEdit={allowEdit} countryIso2={orgCountry} style={styles.detailStyle} {...props} />
      </div>
    </>
  )
}
